import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import $ from 'jquery';
import classnames from 'classnames';

const GLOBAL = require('../../Globals');

class Skill extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			skill : '',
			weight : '',
			subskill : '',
			skills : '',
			topic : '',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			secs : [],
			subj : [],
			id : '',
			data : [],
			sdata : [],
			activeTab: '1'
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubSubmit = this.onSubSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleSubClick = this.handleSubClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onSubClick = this.onSubClick.bind(this);
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** reset Skill form **/
	onClick(e){
		
		document.getElementById("skillform").reset();
	}
	
	/** reset Sub Skill form **/
	onSubClick(e){
		
		document.getElementById("subskillform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.skill){
			
			PostData('exam/addskill',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Skill added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("skillform").reset();
					this.getdata();	
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	onSubSubmit(e){
		e.preventDefault();
		
		if(this.state.skills && this.state.subskill && this.state.weight){
			
			PostData('exam/addsubskill',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Sub Skill added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("subskillform").reset();
					this.getsubdata();	
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getskill();
		this.getdata();	
		this.getsubdata();
	}
	
	/* Get Sub Skill Data */
	getsubdata(){
		
		GetData('exam/getsubskill').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					sdata : responseJson
				});
			}
		});
	}
	
	/* Get Skill Data */
	getdata(){
		
		GetData('exam/getskill').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	/** get Skill **/
	getskill(){
		
		GetData('exam/getskill').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('exam/deleteleskill',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Skill Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove LessonPlanning',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	handleSubClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('exam/deletelesubskill',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Sub Skill Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getsubdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove LessonPlanning',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	
  render() {
	
	var items = this.state.posts;
	  
	 /** get Section By Class **/
	$("#clas").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'section/getsectionbyclass/'+fr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Section- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.section)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
	
	/** get Subject By Class & Section **/
	$("#secs").change(function(){
		var cr = $("#clas").val();
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'subjectallocation/getsubjectbysec/'+fr+'/'+cr,function(o){
			//$("#acHead").removeClass('chosen_a');
			$("#sub").html('');
			$('#sub')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select Subject- ')); 
			$.each(o,function(key,value){			
				   $('#sub')
					.append($("<option></option>")
					.attr("value",value.id)
					.text(value.subname)); 	
										
			});	
			//	$("#acHead").addClass('chosen_a');
			
		},'json');
	
	});
  
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
        <Row>
          <Col md="12">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                  Skills
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                  Sub Skills
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
				<Row>
				<Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="skillform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Add Skill</strong>
					</CardHeader>
					<CardBody>
					  <Row>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Skill <span className="text-danger">*</span></Label>
							  <Input type="text" name="skill" required placeholder="Enter Skill" onChange={this.onChange} />
							</FormGroup>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
				</Col>
				<Col md="6">
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Skill</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.data.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.skill}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
				</Col>
				</Row>
			  </TabPane>
			  <TabPane tabId="2">
				<Row>
				<Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="subskillform" encType="multipart/form-data" onSubmit={this.onSubSubmit} >
					<CardHeader>
						<strong>Add Sub Skill</strong>
					</CardHeader>
					<CardBody>
					  <Row>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Skills <span className="text-danger">*</span></Label>
							  <select name="skills" onChange={this.onChange} className="form-control" required >
								<option value="">Select Skills</option>
								{
									items.map(function (item) {
										return <option value={item.id }>{item.skill}</option>;
									})
								}
							  </select>
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Sub Skill <span className="text-danger">*</span></Label>
							  <Input type="text" name="subskill" required placeholder="Enter Sub Skill" onChange={this.onChange} />
							</FormGroup>
						</Col>
						<Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Weightage <span className="text-danger">*</span></Label>
							  <Input type="text" name="weight" required onChange={this.onChange} />
							</FormGroup>
						</Col>
					  </Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						<Button type="reset" size="sm" color="danger" onClick={this.onSubClick}><i className="fa fa-ban"></i> Reset</Button>
					</CardFooter>
				  </form>
				</Card>
				</Col>
				<Col md="6">
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Skill</th>
								<th>Sub Skill</th>
								<th>Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.sdata.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.skill}</td>
									<td>{item.subskill}</td>
									<td>
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleSubClick(item.id)} ><i className="fa fa-remove"></i></button>
									</td>
								</tr>

							 )}
						</tbody>
					</Table>
				</Col>
				</Row>
			  </TabPane>
			</TabContent>
		  </Col>
		</Row>
		</div>
	);
  }
}

export default Skill;


// WEBPACK FOOTER //
// ./src/exams/Skill/Skill.js